import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom"; // ✅ add
import Navbar from "../components/Navbar";
import BottomBar from "../components/BottomNav";
import WallpaperPicker from "./ProfilePage/WallpaperPicker";
import { api } from "../api";
import "./OptionsPage.css";

import { FiEdit2 } from "react-icons/fi";

function wallpaperSrcFromKey(key) {
  if (!key) return "";
  return `/images/wallpapers/${key}.png`;
}

export default function OptionsPage({ user, onLogout, onUpdateProfile }) {

  console.log("[OptionsPage] navigating to home");
  const navigate = useNavigate(); // ✅ add

  const profile = user?.profile || {};
  const currentWallpaperKey = profile.wallpaperKey || "";

  const [editingWallpaper, setEditingWallpaper] = useState(false);
  const [draftWallpaperKey, setDraftWallpaperKey] = useState(currentWallpaperKey);

  const currentWallpaperSrc = useMemo(
    () => wallpaperSrcFromKey(currentWallpaperKey),
    [currentWallpaperKey]
  );

  const draftWallpaperSrc = useMemo(
    () => wallpaperSrcFromKey(draftWallpaperKey),
    [draftWallpaperKey]
  );

  const dirty = draftWallpaperKey !== currentWallpaperKey;

  function openWallpaperEdit() {
    setDraftWallpaperKey(currentWallpaperKey);
    setEditingWallpaper(true);
  }

  function cancelWallpaperEdit() {
    setDraftWallpaperKey(currentWallpaperKey);
    setEditingWallpaper(false);
  }

async function saveWallpaperEdit() {
  try {
    await api("/me/wallpaper", {
      method: "PUT",
      body: { wallpaperKey: draftWallpaperKey },
      invalidatePrefixes: ["/me/profile", "/me/wallpaper"],
    });

    if (draftWallpaperSrc) {
      document.documentElement.style.setProperty("--app-wallpaper", `url(${draftWallpaperSrc})`);
      document.documentElement.style.setProperty("--app-wallpaper-pos", "50% 50%");
    } else {
      document.documentElement.style.setProperty("--app-wallpaper", "");
    }

    if (typeof onUpdateProfile === "function") {
      await onUpdateProfile({ ...profile, wallpaperKey: draftWallpaperKey });
    }

    // ✅ navigate first (replace avoids weird "back" behavior)
    navigate("/", { replace: true });

    // ✅ then close local edit state (safe even if component unmounts)
    setEditingWallpaper(false);
  } catch (err) {
    console.error("Failed to save wallpaper", err);
    alert("Failed to save wallpaper. Please try again.");
  }
}

  // ---------------- Edit mode ----------------
  if (editingWallpaper) {
    return (
      <>
        <Navbar user={user} onLogout={onLogout} tab="profile" />

        <main className="page-wrapper">
          <section className="page-container">
            <div className="glass plan-glass options-card">
              <div className="options-header-row">
                <h2 className="options-header-title">Choose wallpaper</h2>
              </div>

              <WallpaperPicker value={draftWallpaperKey} onChange={setDraftWallpaperKey} />

              <div className="options-actions">
                <button className="btn" type="button" onClick={cancelWallpaperEdit}>
                  Cancel
                </button>

                <button
                  className="btn primary"
                  type="button"
                  onClick={saveWallpaperEdit}
                  disabled={!dirty}
                  title={!dirty ? "Pick a different wallpaper to enable saving" : "Save wallpaper"}
                >
                  Save
                </button>
              </div>
            </div>
          </section>
        </main>

        <BottomBar tab="profile" />
      </>
    );
  }

  // ---------------- Normal view ----------------
  return (
    <>
      <Navbar user={user} onLogout={onLogout} tab="profile" />

      <main className="page-wrapper">
        <section className="page-container">
          <div className="glass plan-glass options-card">
            <div className="options-header-row">
              <h2 className="options-header-title">Options</h2>

              <div className="options-preview-wrap">
                {currentWallpaperSrc ? (
                  <div
                    className="options-preview-thumb"
                    style={{ backgroundImage: `url(${currentWallpaperSrc})` }}
                    aria-label="Current wallpaper"
                  />
                ) : (
                  <div className="options-preview-thumb options-preview-thumb--empty" />
                )}

                <button
                  type="button"
                  className="options-edit-btn"
                  onClick={openWallpaperEdit}
                  aria-label="Edit wallpaper"
                  title="Edit wallpaper"
                >
                  <FiEdit2 size={16} />
                </button>
              </div>
            </div>

            <div className="options-section">
              <div className="muted" style={{ fontSize: 12 }}>
                Wallpaper
              </div>
              <div style={{ marginTop: 6, fontSize: 14 }}>
                {currentWallpaperKey ? currentWallpaperKey : "Default"}
              </div>
            </div>
          </div>
        </section>
      </main>

      <BottomBar tab="profile" />
    </>
  );
}